import React, { useCallback } from 'react';

import {
  default as ToastMessage,
  type ToastConfigParams,
} from 'react-native-toast-message';
import Text from '../Text';
import { Pressable, TouchableOpacity, View } from 'react-native';

import AlertSVG from '~/assets/svgs/alert.svg';
import CloseSVG from '~/assets/svgs/close.svg';
import colors from '~/assets/themes/colors';
import { isWeb } from '~/utils/device';
import Modal from 'react-native-modal';
import Button from '../Button';

export type ToastType =
  | 'success'
  | 'warning'
  | 'error'
  | 'modalAlertIdle'
  | 'modalConfirmationToast';

type ToastConfig = {
  [key in ToastType]: (params: ToastConfigParams<any>) => React.ReactNode;
};

const WarningToast = () => <Text>Warning toast</Text>;
const SucessToast = () => <Text>Sucess toast</Text>;

const ErrorToast = ({ text1, text2, hide }: ToastConfigParams<any>) => {
  return (
    <View className="p-3 border border-feedback-error-main bg-feedback-error-bkg rounded-lg w-[90%]">
      <View className="flex-row justify-between">
        <AlertSVG color={colors.feedback.error.text} width={16} height={16} />
        <View className="ml-1 flex-1">
          {!!text1 && (
            <Text className="text-xs font-medium text-feedback-error-text">
              {text1}
            </Text>
          )}
          {!!text2 && (
            <Text className="text-xs text-feedback-error-text">{text2}</Text>
          )}
        </View>
        <TouchableOpacity onPress={() => hide()} activeOpacity={0.6}>
          <CloseSVG color={colors.feedback.error.text} width={16} height={16} />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const ModalAlertIdleToast = ({ hide, isVisible }: ToastConfigParams<any>) => {
  return (
    <Modal
      isVisible={isVisible}
      onBackdropPress={hide}
      className={isWeb ? 'items-center justify-center' : ''}
    >
      <Pressable
        onPress={() => hide()}
        className={'bg-light-100 p-6 rounded-xl'}
      >
        <View className="items-center justify-center">
          <Text className="text-center leading-6 text-base my-3">
            Você ainda está aí?
          </Text>
        </View>
        <Button onPress={() => hide()}>Estou sim</Button>
      </Pressable>
    </Modal>
  );
};

const ModalConfirmationToast = ({
  hide,
  onPress,
  text1,
  isVisible,
}: ToastConfigParams<any>) => {
  const handlePress = useCallback(() => {
    hide();
    onPress();
  }, [hide, onPress]);

  return (
    <Modal
      isVisible={isVisible}
      onBackdropPress={hide}
      className={isWeb ? 'items-center justify-center' : ''}
    >
      <Pressable
        onPress={() => hide()}
        className={'bg-light-100 p-6 rounded-xl'}
      >
        <View className="items-center justify-center">
          <Text className="text-center leading-6 text-base my-3">{text1}</Text>
        </View>

        <View className="flex-row mt-2">
          <Button className="flex-1 mr-2" onPress={() => hide()}>
            Não
          </Button>

          <Button variant="secondary" className="flex-1" onPress={handlePress}>
            Sim
          </Button>
        </View>
      </Pressable>
    </Modal>
  );
};

const Toast: React.FC = () => {
  const toastConfig: ToastConfig = {
    error: ErrorToast,
    warning: WarningToast,
    success: SucessToast,
    modalAlertIdle: ModalAlertIdleToast,
    modalConfirmationToast: ModalConfirmationToast,
  };

  return (
    <ToastMessage config={toastConfig} position={isWeb ? 'top' : 'bottom'} />
  );
};

export default Toast;
